import request from "@/utils/request";

// 首页-最新课程
export const  humanityLatestCourse =(query) =>{
    return request({
        url: "/authservice/edition/humanity/course",
        method:"get",
        params: query
    })
}

// 首页-分页视频
export const  humanityBymyVideoList =(data) =>{
    return request({
        url: "/authservice/edition/humanity/bymyVideoList",
        method:"post",
        data: data
    })
}

// 首页-检索
export const  humanityRetrieveVideo =(data) =>{
    return request({
        url: "/authservice/edition/humanity/retrieve",
        method:"post",
        data: data
    })
}